// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/kernel/kernel-context.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/kernel/src/context.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo habit-streak-app
//     node fleet/fleet.ts check --repo habit-streak-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
/**
 * PLUGIN-KERNEL — the READING half of the kernel context.
 *
 * Split out of `kernel-provider.tsx` so that a page contributed by a plugin can
 * read its feature's service without importing the provider. The provider
 * imports `appComposition`, and the composition names the pages its plugins
 * own; a page that reached back into the provider would close that circle and
 * make module initialisation order load-bearing.
 *
 * The type this carries is generic — so nothing here depends on a product module
 * at compile time or runtime.
 */
import { type Accessor, createContext, useContext } from "solid-js";
import type { MountedApp, ServiceToken } from "./index";

export interface KernelContribution {
  kind: string;
  item?: unknown;
  command?: unknown;
  binding?: unknown;
  [key: string]: unknown;
}

export const KernelContext = createContext<Accessor<MountedApp<unknown>>>();

/** The composition mounted for the CURRENT account. Never cache the result. */
export function useKernel<T = KernelContribution>(): Accessor<MountedApp<T>> {
  const ctx = useContext(KernelContext);
  if (!ctx) {
    throw new Error("useKernel must be used inside <KernelProvider>");
  }
  // oxlint-disable-next-line typescript/no-unsafe-type-assertion
  return ctx as unknown as Accessor<MountedApp<T>>;
}

/**
 * A service published by a plugin, or `undefined` when the plugin was not
 * mounted here (capability missing, or not in this app's composition).
 * Callers MUST handle `undefined`; that is the whole point of capability gating.
 */
export function useKernelService<T>(token: ServiceToken<T>): Accessor<T | undefined> {
  const app = useKernel();
  return () => app().tryService(token);
}
